export enum PlayerTestIds {
    PLAY_PAUSE_CONTROL = 'video_play_btn',
    OVERLAY_CONTROL = 'video_overlay',
    PROGRESS_BAR_CONTROL = 'video_progress',
    VOLUME_CONTROL = "video_volume_control"
}